import { Routes } from '@angular/router';
import { cmsModuleRoutes } from './utilities-apps/cms/cms-routing.module';
import { uaaModuleRoutes } from './utilities-apps/uaa/uaa-routing.module';

export const superAdminUtilitiesRoutes: Routes = [
  { path: '', redirectTo: 'institutions', pathMatch: 'full', data: { isNotAMenuItem: true } },
  {
    path: 'uaa',
    data: {
      name: 'User Management',
      icon: 'admin_panel_settings',
      iconType: 'MAT',
    },
    children: [...uaaModuleRoutes],
  },
  {
    path: 'institutions',
    data: {
      name: 'Institutions',
      icon: 'corporate_fare',
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../system-utilities/utilities-apps/institutions/institutions').then(
            (m) => m.Institutions,
          ),
      },
      {
        path: ':id',
        data: { isNotAMenuItem: true, name: 'Institution Details' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../system-utilities/utilities-apps/institutions/institution-detail/institution-detail').then(
                (m) => m.InstitutionDetail,
              ),
          },
          {
            path: 'organogram',
            loadComponent: () =>
              import('../system-utilities/utilities-apps/institutions/organogram/organogram').then(
                (m) => m.Organogram,
              ),
            data: { isNotAMenuItem: true, name: 'Organogram' },
          },
        ],
      },
    ],
  },
  {
    path: 'financial-year',
    loadComponent: () =>
      import('../system-utilities/utilities-apps/financial-year/financial-year').then(
        (m) => m.FinancialYear,
      ),
    data: {
      name: 'Financial Year',
      icon: 'payments',
      hideRefresh: true,
      isNotAMenuItem: true,
    },
  },
  {
    path: 'translations',
    loadComponent: () =>
      import('./utilities-apps/translations/translations').then((m) => m.Translations),
    data: {
      name: 'Translations',
      icon: 'translate',
    },
  },
  {
    path: 'locations',
    loadComponent: () =>
      import('../system-utilities/utilities-apps/locations/locations').then((m) => m.Locations),
    data: {
      name: 'Locations',
      icon: 'place',
    },
  },
  {
    path: 'designations',
    loadComponent: () =>
      import('../system-utilities/utilities-apps/designations/designations').then(
        (m) => m.Designations,
      ),
    data: {
      name: 'Designations',
      icon: 'badge',
      isNotAMenuItem: true,
    },
  },
  {
    path: 'sectors',
    loadComponent: () =>
      import('../system-utilities/utilities-apps/sectors/sectors').then(
        (m) => m.Sectors,
      ),
    data: {
      name: 'Sectors',
      icon: 'category',
      iconType: 'MAT',
    },
  },
  {
    path: 'cms',
    data: {
      name: 'CMS',
      icon: 'widgets',
    },
    children: [...cmsModuleRoutes],
  },
];
